import {useCallback} from "react"
import {messagesService} from "@dv5/api"

interface UseDiagramWidgetUpdateProps {
    canvasId: string
    widgetId: string
}

export function useDiagramWidgetUpdate({canvasId, widgetId}: UseDiagramWidgetUpdateProps) {
    const updateData = useCallback((patchedPaths: string[], newData: Record<string, unknown>) => {
        messagesService.send('canvas.change-widget-data', {
            canvasId,
            widgetId,
            patchedPaths,
            data: newData,
        })
    }, [canvasId, widgetId])

    return {updateData}
}
